var styles = {"fontElementMap":"yE2pO","orderedlist":"_63Ca9","bulletedlist":"YKwzb","listItem":"XooYz"};

export { styles as s };
//# sourceMappingURL=lists-78011f58.js.map
